export default __webpack_public_path__ + "static/media/rare4.99d02b53.gif";